import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "One roof. Every tool.",
    body: "No more piecing recovery together across town. Compression, heat, cold, light, salt, oxygen and float — a complete recovery stack lives under one roof in North Phoenix, sequenced around how you train."
  },
  {
    n: "02",
    title: "Heat. Cold. Light. Pressure.",
    body: "Contrast is the engine of adaptation. Move from infrared sauna to cold plunge, red light to PEMF — protocols built on stress and release so your body rebuilds faster than it breaks down."
  },
  {
    n: "03",
    title: "Recover like it's your job.",
    body: "Training is only half the equation. The most consistent performers treat recovery as a discipline — HBOT after heavy blocks, salt floats before big weeks, compression on repeat. The edge compounds."
  },
  {
    n: "04",
    title: "Start with the Experience.",
    body: "Every journey on our floor begins the same way: a complimentary, staff-guided Recovery Experience built around your goals. Two to three signature modalities, zero pressure — just proof of what deliberate recovery feels like."
  }
];

export const Chapters = () => (
  <section className="mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40" data-testid="manifesto-chapters">
    <motion.p
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7 }}
      className="mb-20 font-mono text-xs uppercase tracking-[0.25em] text-rest-blue"
    >
      The REST Manifesto
    </motion.p>
    <div className="space-y-24 md:space-y-32">
      {chapters.map((c, i) => (
        <motion.div
          key={c.n}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className={`grid gap-6 md:grid-cols-12 ${i % 2 === 1 ? "md:text-right" : ""}`}
          data-testid={`chapter-${c.n}`}
        >
          <div className={`md:col-span-3 ${i % 2 === 1 ? "md:order-2" : ""}`}>
            <span className="font-display text-6xl font-black text-outline-red md:text-8xl">{c.n}</span>
          </div>
          <div className={`md:col-span-9 ${i % 2 === 1 ? "md:order-1" : ""}`}>
            <h2 className="font-display text-3xl font-black uppercase tracking-tighter md:text-5xl">{c.title}</h2>
            <p className={`mt-6 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg ${i % 2 === 1 ? "md:ml-auto" : ""}`}>
              {c.body}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
